import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { staggerRevealOnScroll } from '../../utils/animations';
import styles from './Team.module.scss';
import rashikaImg from '../../assets/images/Rashika_nagotra.jpeg';
import himanshuImg from '../../assets/images/himanshu_nagotra.png';
import surjeetImg from '../../assets/images/gurmeet_singh_sherfgill_crm.jpeg';
import snehalImg from '../../assets/images/Snehal_Shiv_HR.jpeg';
import ajinkiyaImg from '../../assets/images/ajinkiya_khare.png';
import ramandeepImg from '../../assets/images/ramandeep_kaur.jpeg';
import payalImg from '../../assets/images/payal_bhadoriya_bde.jpeg';
import abhishekImg from '../../assets/images/abhishek_nagwanshi.jpeg';

const teamMembers = [
  {
    name: 'Rashika Nagotra',
    role: 'Digital Marketing Head',
    image: rashikaImg
  },
  {
    name: 'Ajinkiya Khare',
    role: 'Digital Marketing Expert',
    image: ajinkiyaImg
  },
  {
    name: 'Ramandeep Kaur',
    role: 'Growth Specialist',
    image: ramandeepImg
  },
  {
    name: 'Payal Bhadoriya',
    role: 'Business Development Executive',
    image: payalImg
  },
  {
    name: 'Abhishek Nagwanshi',
    role: 'Graphic Designer',
    image: abhishekImg
  },
  {
    name: 'Himanshu Nagotra',
    role: 'Video Shoot & Graphic Designer',
    image: himanshuImg
  },
  {
    name: 'Surjeet Singh Shergill',
    role: 'CRM Support Specialist',
    image: surjeetImg
  },
  {
    name: 'Snehal Shiv',
    role: 'HR Manager',
    image: snehalImg
  }
];

const Team: React.FC = () => {
  const gridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Rely on pure CSS stagger animations for rendering reliability
  }, []);

  return (
    <section className={styles.teamSection} id="team">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.sectionTitle}>The <span className={styles.highlight}>Experts</span></h2>
          <p className={styles.sectionSubtitle}>Meet the minds driving your digital growth.</p>
        </div>

        <div ref={gridRef} className={styles.grid}>
          {teamMembers.map((member, index) => (
            <div key={index} className={`${styles.memberCard} hover-target`}>
              <div className={styles.imageWrapper}>
                {member.image ? (
                  <img src={member.image} alt={member.name} className={styles.memberImage} />
                ) : (
                  <div className={styles.placeholderAvatar}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
                    </svg>
                  </div>
                )}
                <div className={styles.overlay}></div>
              </div>
              <div className={styles.info}>
                <h3 className={styles.name}>{member.name}</h3>
                <p className={styles.role}>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
